var _g, _line, _g2, _g3, _g4, _line2, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeilingToFloorArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "242px",
    height: "232px",
    viewBox: "0 0 644.3 619",
    enableBackground: "new 0 0 644.3 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 36.1,
    y1: 77.3,
    x2: 36.1,
    y2: 592.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "27.1,79.9 36.1,64.3 45.1,79.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "27.1,589.7 36.1,605.3 45.1,589.7  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.2726,
    x1: 3,
    y1: 607.4,
    x2: 562.3,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M570.7,608.5v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H570.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M581.5,608.5v-13.3h1.7V607h6.2v1.5H581.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M591.9,605.3c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9s1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5s-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9C593.2,607.2,592.4,606.4,591.9,605.3z M592.8,601.8c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9 c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5 c-1.5,0-2.7,0.5-3.6,1.5C593.2,598.9,592.8,600.2,592.8,601.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M607.2,605.3c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9s1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5s-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9C608.5,607.2,607.7,606.4,607.2,605.3z M608.1,601.8c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9 c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5 c-1.5,0-2.7,0.5-3.6,1.5C608.5,598.9,608.1,600.2,608.1,601.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M622.2,608.5v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6s-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8s-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H622.2z M623.8,601.7h3.5c0.8,0,1.4-0.2,1.9-0.7 s0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V601.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 77.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 74.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 74.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.4,
    y: 64.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 64.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 503.1,105.9 512.6,96.3 52.9,96.3 61.8,105.9 501.8,105.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.6,
    y: 64.2,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  })))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.1355,
    x1: 3.6,
    y1: 62.8,
    x2: 561.6,
    y2: 62.8
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M573.2,69c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 s1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4s-1.4-0.5-2.1-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5s1.2-0.8,1.6-1.4l1.4,0.8 c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5s-1.6-0.8-2.2-1.4C574,70.6,573.5,69.8,573.2,69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M586.7,72.8V59.5h8.7V61h-7.1v4.3h6.9v1.5h-6.9v4.6h7.1v1.5H586.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M598.1,72.8V59.5h1.7v13.3H598.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M602.6,72.8V59.5h1.7v11.9h6.2v1.5H602.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M612.7,72.8V59.5h1.7v13.3H612.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M617.5,72.8V59.5h1.7l7.7,10.4V59.5h1.7v13.3h-1.6l-7.8-10.6v10.6H617.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M631.6,69c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3c-0.7-0.3-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 c-1,1-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4 c0.6-0.3,1.2-0.6,1.5-1v-2.7H637V66h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5 s-1.6-0.8-2.2-1.4C632.5,70.6,632,69.9,631.6,69z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingToFloorArc);
export default __webpack_public_path__ + "static/media/CeilingToFloor_arc.252d0c096c814218a792ac34ac8e1393.svg";
export { ForwardRef as ReactComponent };